import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Prompts } from '~/components/prompts/Prompts';
import { useActions } from '~/stores/use-actions/useActions';
import { RenderChatSubmitProps } from '~/views/widgets/Widgets';

import { ChatSubmit } from './chat-submit/ChatSubmit';
import { Messages } from './messages/Messages';
import * as S from './Reasoner.styles';
import { useChat } from './use-chat/useChat';

export interface IntelProps {
  renderChatSubmit: (props?: RenderChatSubmitProps) => ReactNode;
}

export const Reasoner = () => {
  // This is to prevent a second translations lazy loading after a message is render.
  const { t } = useTranslation([
    'intel',
    'widget',
    'scenarioCommander',
    'analyze',
    'chart',
    'countries',
  ]);

  const { messages } = useChat(state => ({
    messages: state.messages,
  }));
  const actions = useActions(state => state.actions);

  const hasMessages = messages.length > 0;
  const hasActions = actions.length > 0;

  return (
    <S.MainContent>
      {hasMessages && (
        <S.ChatView>
          <Messages messages={messages} />
          {hasActions && <Prompts actions={actions} />}
        </S.ChatView>
      )}
      <S.ChatWrapper $hasMessage={hasMessages}>
        {!hasMessages && (
          <>
            <S.AlfredIcon iconName="AlfredNav" size={48} />
            <S.Title>{t('intel:emptyTitle')}</S.Title>
          </>
        )}

        <ChatSubmit />
      </S.ChatWrapper>
    </S.MainContent>
  );
};
